<template>
    <v-card max-width="60%" min-width="30%" class="rounded-card">
      <!-- <v-card-title>
        <v-spacer></v-spacer>
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small dark icon v-bind="attrs" v-on="on">
              <v-icon small color="black">keyboard_arrow_down</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title> -->
      <v-card-text class="font-weight-medium">
        <div v-if="message.is_media === 1 && message.media_type === 'IMAGE'">
          <a :href="message.media_url" target="”_blank”">
             <v-card flat width="200">
              <v-img :src="message.media_url" aspect-ratio="1.7" height="200" max-width>
              </v-img>
              <v-card-text class="font-weight-medium black--text">
                {{ message.message }}
              </v-card-text>
            </v-card>
          </a>
        </div>
        <div v-if="message.is_media === 1 && message.media_type === 'VIDEO'">
          <vue-player :src="message.media_url" :title="message.message" v-model="playing"></vue-player>
          <v-row align="end" class="fill-height">
            <v-col>
              <div class="font-weight-medium black--text">{{ message.message }}</div>
            </v-col>
          </v-row>
        </div>
        <div v-if="message.is_media === 1 && message.media_type === 'AUDIO'">
          <vue-audio :file="message.media_url"></vue-audio>
          <v-row align="end" class="fill-height">
            <v-col>
              <div class="font-weight-medium black--text">{{ message.message }}</div>
            </v-col>
          </v-row>
        </div>
        <div v-if="message.is_media === 1 && message.media_type === 'PDF'">
          <embed :src="message.media_url" width="200px" height="200px" />
          <v-row align="end" class="fill-height">
            <a :href="message.media_url" target="”_blank”">Open</a>
            <v-col>
              <div class="font-weight-medium black--text">{{ message.message }}</div>
            </v-col>
          </v-row>
        </div>
        <div
          v-if="message.is_media === 1 && (message.media_type === 'MEDIA' || message.media_type === null)"
        >
          <a :href="message.media_url" target="”_blank”">MEDIA</a>
          <v-row align="end" class="fill-height">
            <a :href="message.media_url" target="”_blank”">Open</a>
            <v-col>
              <div class="font-weight-medium black--text">{{ message.message }}</div>
            </v-col>
          </v-row>
        </div>
        <div
          style="white-space: pre-line;"
          v-if="message.is_media !==1 && !message.is_image !== 1"
          class="font-weight-medium black--text"
          v-html="message.message"
        ></div>

        <v-row justify="end">
          <span class="ml-4 px-1 caption grey--text">{{message.created_at | formatdate}}</span>
        </v-row>
      </v-card-text>
    </v-card>
</template>
<script>

import vuePlayer from '@algoz098/vue-player'
import VueAudio from 'vue-audio'
export default {
  props: ['message'],
  components: {
    vuePlayer,
    VueAudio
  },
  data: () => ({
    playing: false
  }),
  methods: {
  }
}
</script>
<style>
.rounded-card{
    border-radius:20px !important;
}
</style>
